module.exports = __webpack_public_path__ + "static/s2-de21bc2ff0275ee90a73cc26cc054072.jpg";